import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../components/utils";

export const detailsUser = createAsyncThunk("user/detailsUser", 
                            async (id, {getState, rejectWithValue }) => {
    try {
        const { auth } = getState();
        const { userInfo } = auth;
        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
            }
        }
        const URL = BASE_URL;
        const { data } = await axios.get(`${URL}/api/users/user/${id}`, config);

        return data;
    } catch(err){
        const message = err.response && err.response.data.message 
                        ? err.response.data.message
                        : err.message;
        return rejectWithValue(JSON.stringify(message));
    }
});

const initialState = {
    status: null,
    error: "",
    user: {},
};

const profileSlice = createSlice({
    name: "userProfile",
    initialState,
    reducers: {
        resetProfile(state, action) {
            return {
                ...state,
                status: null,
                error: "",
                user: {}
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(detailsUser.pending, (state, action) => {
            return { ...state, status: "pending" };
        });
        builder.addCase(detailsUser.fulfilled, (state, action) => {
            if(action.payload) {
                return {
                    ...state,
                   status: "fulfilled",
                    user: action.payload
                };
            } else {
                return state;
            }
        });
        builder.addCase(detailsUser.rejected, (state, action) => {
            return {
                ...state,
                status: "rejected",
                error: action.payload
            }
        });
    }
});

export const { resetProfile } = profileSlice.actions;
export default profileSlice.reducer;
